import { Box, Button, Text } from '@chakra-ui/react';
import React, { useRef, useState } from 'react';
import { CompletedProps } from '../interfaces/components';
import OpenBoxVideo from '../assets/videos/OpenBoxVideo.mp4';
import ReactPlayer from 'react-player';
import { LoccitaneClose } from '../Icons/LoccitaneClose';
import { CompletedModal } from '../content';
import { dispatchCTAClickObject } from '../Analytics';

export interface InstructionImages {
  text: string;
  textAR: string;
  image: string;
}

const Completed = ({ activeLocale, active, setActive }: CompletedProps) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const player = useRef<any>(null);
  const [playing, setPlaying] = useState(false);
  const [videoEnded, setVideoEnded] = useState(false);
  const [hideButton, setHideButton] = useState(false);
  const [isCopied, setIsCopied] = useState(false);

  const handleCopyClick = () => {
    navigator.clipboard
      .writeText('JOY')
      .then(() => {
        setIsCopied(true);
      })
      .catch((err) => {
        console.error('Failed to copy: ', err);
      });

    setTimeout(() => {
      setIsCopied(false);
    }, 1000);
  };

  return (
    <>
      <Box
        position="fixed"
        w="100%"
        h="100%"
        top="0"
        left="0"
        opacity={active ? 1 : 0}
        visibility={active ? 'visible' : 'hidden'}
        backgroundColor="rgba(0,0,0,0.2)"
        transition="all 1s"
        zIndex="9"
        onClick={() => {
          setActive();
          setTimeout(() => {
            setPlaying(false);
            setVideoEnded(false);
            setHideButton(false);
            setIsCopied(false);
            player.current && player.current?.seekTo(0, 'seconds');
          }, 500);
        }}
      />

      <Box
        zIndex="10"
        opacity={active ? 1 : 0}
        visibility={active ? 'visible' : 'hidden'}
        transition="all 0.5s"
        position="fixed"
        top={0}
        right={0}
        left={0}
        bottom={0}
        margin="auto"
        bg="white"
        padding={['15px', '20px', '25px', '25px']}
        width={['90vw', '350px', '450px', '500px', '500px']}
        height={['380px', '460px', '450px', '500px', '500px']}
      >
        <LoccitaneClose
          boxSize={[6, 6, 8]}
          position="absolute"
          top={['25px', '30px', '35px']}
          right={['25px', '30px', '35px']}
          cursor="pointer"
          fill="black"
          strokeWidth={0.5}
          onClick={() => {
            setActive();
            setTimeout(() => {
              setPlaying(false);
              setVideoEnded(false);
              setHideButton(false);
              setIsCopied(false);
              player.current && player.current?.seekTo(0, 'seconds');
            }, 500);
          }}
          zIndex={30}
          stroke="#CCCCCC"
          borderRadius="100%"
          _hover={{ stroke: 'black' }}
          transition=".5s"
        />

        <Text
          w={['80%', '260px', '280px', '280px', '280px']}
          fontSize={['13px', '14px', '18px', '18px', '18px']}
          fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayMedium'}
          position="absolute"
          left="0"
          right="0"
          top={['45px', '55px', '55px', '55px', '55px']}
          zIndex={10}
          textAlign="center"
          margin="auto"
        >
          {activeLocale === undefined || !((activeLocale as keyof typeof CompletedModal) in CompletedModal)
            ? CompletedModal['en'].textOne
            : CompletedModal[activeLocale as keyof typeof CompletedModal].textOne}
        </Text>

        <Box
          // opacity={videoEnded ? 1 : 0}
          display={videoEnded ? 'flex' : 'none'}
          transition="all 0.5s"
          w={['60vw', '240px', '280px', '300px', '300px']}
          h={['160px', '170px', '180px', '200px', '200px']}
          borderRadius="none"
          bg="white"
          boxShadow="rgba(0, 0, 0, 0.35) 0px 5px 15px"
          position="absolute"
          top={0}
          right={0}
          left={0}
          bottom={0}
          margin="auto"
          zIndex={10}
          flexDir="column"
          justifyContent="space-between"
          alignItems="center"
          p={['10px', '20px', '15px', '20px', '20px']}
        >
          <Text
            w={['55vw', '220px', '220px', '220px', '220px']}
            fontSize={['13px', '14px', '15px', '15px', '15px']}
            fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayMedium'}
            textAlign="center"
          >
            {activeLocale === undefined || !((activeLocale as keyof typeof CompletedModal) in CompletedModal)
              ? CompletedModal['en'].textTwo
              : CompletedModal[activeLocale as keyof typeof CompletedModal].textTwo}
          </Text>

          <Box border="1px solid black" p={['10px']}>
            <Text
              fontSize={['13px', '14px', '18px', '18px', '18px']}
              fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayMedium'}
              display="flex"
              flexDirection={activeLocale === 'ar' ? 'row-reverse' : 'row'}
            >
              {activeLocale === undefined || !((activeLocale as keyof typeof CompletedModal) in CompletedModal)
                ? CompletedModal['en'].textThree
                : CompletedModal[activeLocale as keyof typeof CompletedModal].textThree}
              <span style={{ fontWeight: 900 }}>JOY</span>
            </Text>
          </Box>

          <Button
            fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayMedium'}
            variant="link"
            color="black"
            textDecor="underline"
            onClick={() => handleCopyClick()}
          >
            {isCopied
              ? activeLocale === undefined || !((activeLocale as keyof typeof CompletedModal) in CompletedModal)
                ? CompletedModal['en'].textFourSucc
                : CompletedModal[activeLocale as keyof typeof CompletedModal].textFourSucc
              : activeLocale === undefined || !((activeLocale as keyof typeof CompletedModal) in CompletedModal)
              ? CompletedModal['en'].textFour
              : CompletedModal[activeLocale as keyof typeof CompletedModal].textFour}
          </Button>
        </Box>

        <Button
          // opacity={!hideButton ? 1 : 0}
          display={!hideButton ? 'unset' : 'none'}
          transition="all 0.5s"
          w={['100px']}
          borderRadius="none"
          bg="white"
          boxShadow="rgba(0, 0, 0, 0.35) 0px 5px 15px"
          position="absolute"
          top={0}
          right={0}
          left={0}
          bottom={0}
          margin="auto"
          zIndex={10}
          onClick={() => {
            setPlaying(true);
            setHideButton(true);
            dispatchCTAClickObject('loccitane', 'button', 'minigameReward', 'open', '');
          }}
          fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'LoccitaneRegular'}
        >
          {activeLocale === undefined || !((activeLocale as keyof typeof CompletedModal) in CompletedModal)
            ? CompletedModal['en'].button
            : CompletedModal[activeLocale as keyof typeof CompletedModal].button}
        </Button>

        <Text
          w={['60%', '60%', '80%', '100%']}
          fontSize={['16px', '18px', '25px', '25px', '25px']}
          fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'LoccitaneRegular'}
          fontWeight="500"
          position="absolute"
          left="0"
          right="0"
          bottom={['35px', '45px', '45px', '45px', '45px']}
          zIndex={10}
          textAlign="center"
          margin="auto"
        >
          {activeLocale === undefined || !((activeLocale as keyof typeof CompletedModal) in CompletedModal)
            ? CompletedModal['en'].textFive
            : CompletedModal[activeLocale as keyof typeof CompletedModal].textFive}
        </Text>

        <Box height="100%" width="100%" position="relative" border="5px solid #FFCB00">
          <ReactPlayer
            ref={player}
            id="minigame-screen-video"
            height="100%"
            width="100%"
            style={{ objectFit: 'cover' }}
            loop={false}
            muted
            controls={false}
            playing={playing}
            url={OpenBoxVideo}
            onEnded={() => {
              setVideoEnded(true);
            }}
            playsinline
          />
        </Box>
      </Box>
    </>
  );
};
export default Completed;
